function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.161 1.571a.13.13 0 00-.184 0l-8.332 8.333a.433.433 0 00-.126.278l-.155 2.315a.13.13 0 00.138.139l2.316-.155a.434.434 0 00.278-.126l8.333-8.333a.13.13 0 000-.183L20.16 1.57zm.521-1.317a.867.867 0 00-1.225 0l-8.732 8.731a1.734 1.734 0 00-.503 1.11l-.22 3.304c-.023.34.259.622.599.6l3.304-.22a1.734 1.734 0 001.11-.504l8.731-8.732a.867.867 0 000-1.225L20.682.254z",
  fill: "#F15045"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.54 3C3.69 3 3 3.69 3 4.54v14.92c0 .85.69 1.54 1.54 1.54h14.92c.85 0 1.54-.69 1.54-1.54v-7.08a.38.38 0 00-.38-.38h-.662a.38.38 0 00-.38.38v7.08a.118.118 0 01-.118.118H4.54a.118.118 0 01-.118-.118V4.54c0-.066.052-.118.118-.118h7.083c.21 0 .38-.17.38-.38V3.38a.38.38 0 00-.38-.379H4.54z",
  fill: "#F15045"
});

var SvgReview = function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgReview;